import { NAME } from './constants';
import { router } from './router';

export const UzaverkaPokladen = {
	name: NAME,
	router,
};
